module.exports = __webpack_public_path__ + "img/seating-map-3.135780bb.png";